import styled from '@emotion/styled';
import React from 'react';
import { Link } from 'react-router-dom';

const StyledDropdown = styled.div`
	width: 100%;
	max-width: 780px;
	box-shadow: 0 0 0 1px rgb(53 72 91 / 4%), 0 2px 2px rgb(0 0 0 / 0%),
		0 4px 4px rgb(0 0 0 / 1%), 0 10px 8px rgb(0 0 0 / 2%),
		0 15px 15px rgb(0 0 0 / 2%), 0 30px 30px rgb(0 0 0 / 2%),
		0 70px 65px rgb(0 0 0 / 3%);
	border-radius: 0 0 5px 5px;
	position: absolute;
	top: 52px;
	background: #fff;

	> a {
		padding: 10px;
		border-bottom: 1px solid #ccc;
		color: #545454;
		transition: all 0.3s ease-in-out;

		&:hover {
			color: #212121;
			background-color: rgba(0, 0, 0, 0.09);
		}

		&:last-of-type {
			border: 0;
		}
	}

	label.search-error {
		font-size: 14px;
		line-height: 20px;
	}
`;

function SearchDropdown({ suggestions, brandData }) {
	return (
		<StyledDropdown className='d-flex flex-column'>
			{suggestions.length ? (
				suggestions
					?.filter((data) => {
						return (
							data.item.market !== 'au-vws-only' &&
							(data.item.market ===
								`${brandData.country.toLowerCase()}-market` ||
								data.item.market === 'apac-market')
						);
					})
					.map(({ item: { title, categorySlug, slug } }, index) => {
						return (
							<Link
								to={{
									pathname: `/customer-services/faq/${categorySlug}/${slug}`
								}}
								className='text-decoration-none'
								key={index}
							>
								{title}
							</Link>
						);
					})
			) : (
				<label className='alert alert-warning form-error search-error'>
					{"Sorry, but we're having a technical issue. Please call our customer service department at " +
						brandData.phone +
						' – they’ll be more than happy to assist you.'}
				</label>
			)}
		</StyledDropdown>
	);
}

export default SearchDropdown;
